"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/CancelScheduledModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _scheduledMessages = require('shared/services/scheduledMessages');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);









// Cancel asks first. The composer is left alone; a toast then offers Undo.
const CancelScheduledModal = ({ isOpen, recipientName, onClose, onProceed }) => (
  _react2.default.createElement(_Modal2.default, {
    isOpen: isOpen,
    onClose: onClose,
    title: "Cancel this scheduled message?"   ,
    size: "xs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}}

    , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}, _scheduledMessages.cancelScheduledBody.call(void 0, recipientName))
    , _react2.default.createElement(_Modal.ModalControls, {
      primaryBtnTheme: "danger",
      primaryBtnLabel: "Cancel message" ,
      secondaryBtnLabel: "Keep it" ,
      onPrimaryBtnClick: onProceed,
      onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
    )
  )
)

exports. default = _react.memo.call(void 0, CancelScheduledModal)
